<template>
    <div class="article-expertise">
        <p>
            Crude oil tankers are essential for transporting unrefined crude oil from extraction points to refineries.
            At GSC TankerCare, we understand the unique needs of these specialised vessels:
        </p>
        <ul>
            <li>
                <strong>Size and Capacity:</strong>
                From VLCCs to ULCCs, we work with tankers capable of carrying millions of barrels of oil.
            </li>
            <li>
                <strong>Tank Structure:</strong>
                We ensure proper cleaning and maintenance of double-hulled tanks designed for safety and spill
                prevention.
            </li>
            <li>
                <strong>Operational Efficiency:</strong>
                Our services optimise the performance and longevity of these vessels while maintaining compliance with
                industry regulations.
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    name: 'ArticleExpertise',
};
</script>
